// Modularity
import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { regex } from '../../utils/Regex';

// Components
import Spinner from '../../components/Spinner/Spinner';
import { userLogin } from '../../utils/api/axiosCalls';
import { signIn } from '../../core/store/slices/authSlice';
import { setUser } from '../../core/store/slices/userSlice';
import Input from '../../components/ReusableComponent/Input/Input';
import Button from '../../components/ReusableComponent/Button/Button';
import { closeLoader, showLoader } from '../../core/store/slices/loaderSlice';

// Styles
import { LoginConatiner } from './Auth.style';
import { useAppDispatch } from '../../core/hooks/hooks';
import { toastifyWarn } from '../../utils/toastify';
import { useMount } from 'react-use';

const Login = () => {
	const navigate = useNavigate();
	useEffect(() => {
		if (localStorage.getItem('user')) {
			navigate('/');
		}
	}, []);
	const { t } = useTranslation();
	const dispatch = useAppDispatch();

	const [credentials, setCredentials] = useState({
		email: '',
		password: '',
		role: 'member',
	});
	const [err, setErr] = useState({
		email: '',
		password: '',
	});

	const handellValidtaionInput = (value: any, key: string) => {
		let valid: boolean = true;
		let errMsg: string = '';
		if (!value || value === '') {
			valid = false;
			errMsg = `${t('Required field')}`;
		} else if (key === 'email' && !regex.emailRegex.test(value)) {
			valid = false;
			errMsg = `${t(`Inavlid ${key} `)}`;
		} else if (key === 'password' && value.length < Number('8')) {
			valid = false;
			errMsg = `Minimum Password Length is 8`;
		} else if (key === 'password' && value.length > Number('20')) {
			valid = false;
			errMsg = `Maximum Password Length is 20`;
		}

		return { valid, errMsg };
	};

	const handellValidtaionInputs = (obj: object) => {
		let validInput: any[] = [];
		let err: { email: string; password: string } = {
			email: '',
			password: '',
		};

		for (const key in obj) {
			const element = obj[key];
			const { valid, errMsg } = handellValidtaionInput(element, key);
			validInput.push(valid);
			err[key] = errMsg;
		}
		const validObj = validInput.every((element) => element);

		return { validObj, err };
	};

	const onChangeInput = (e: any) => {
		const { name, value } = e.target;
		const { errMsg } = handellValidtaionInput(value, name);
		setErr((prev) => ({ ...prev, [name]: errMsg }));
		setCredentials((prev) => ({ ...prev, [name]: value }));
	};

	const handellSubmit = async () => {
		const { validObj, err } = handellValidtaionInputs(credentials);
		setErr(err);
		if (!validObj) {
			return;
		}
		dispatch(showLoader({ show: true, animation: <Spinner /> }));
		try {
			const userData = await userLogin(credentials);
			dispatch(signIn(userData));
			dispatch(closeLoader());
			localStorage.setItem('user', JSON.stringify(userData.user));

			if (userData?.user?.first_time == 1) {
				toastifyWarn('You Need To Change Your Password');
				navigate('/my-profile', { state: 1 });
			} else {
				navigate('/');
			}

			const { name, email, gender, date_of_birth, about } = userData.user;
			const user = {
				loggedIn: true,
				name,
				email,
				about,
				gender,
				dateOfBirth: new Date(moment(date_of_birth, 'YYYY-MM-DD').format('YYYY/MM/DD')),
			};
			dispatch(setUser(user));
		} catch (error) {
			dispatch(closeLoader());
		}
	};
	const [searchParams] = useSearchParams();
	const [hasToken, setHasToken] = useState<boolean>(false);

	useMount(() => {
		setHasToken(searchParams.has('token') && process.env.REACT_APP_TOKEN === searchParams.get('token') ? true : false);
	});
	if (!hasToken) {
		return <div className="h-100 w-100 absolute right-0 bg-white"></div>;
	}

	return (
		<LoginConatiner>
			<div className="partial head">
				<p className="Login__title">{`${t('Login')}`}</p>
				<p className="header">{`${t('LoginMsg')}`}</p>
			</div>
			<div className="partial inputs">
				<Input
					className="login__inputs"
					lable={`${t('Email Address')}`}
					name="email"
					type="text"
					placeholder={`${t('Enter your email')}`}
					value={credentials.email}
					onChange={onChangeInput}
					err={err.email}
				/>
				<Input
					className="login__inputs"
					lable={`${t('Password')}`}
					name="password"
					type="password"
					placeholder={`${t('Password')}`}
					value={credentials.password}
					onChange={onChangeInput}
					err={err.password}
				/>
				<Link to="/forget-password" className="forgetPass">
					{`${t('Forgot Password')}`}
				</Link>
			</div>

			<Button onClick={handellSubmit} label={`${t('LoginBtn')}`} width="100%" rounded />
			<p className="footer">{t('© 2023 all rights reserved')} </p>
		</LoginConatiner>
	);
};

export default Login;
